import React, { useState, useEffect } from 'react';
import serviceApi from '../../../services/serviceApi';
import environment from '../../../environments/environment';

interface LiveClass {
    subject: string;
    title: string;
    time: string;
    endTime: string;
    meetingUrl: string;
    isNow: boolean;
}

const LiveClasses: React.FC = () => {
    const [liveClasses, setLiveClasses] = useState<LiveClass[]>([]);
    // const [selectedUrl, setSelectedUrl] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    const getEffectiveClass = (): string => {
        try {
            const s = localStorage.getItem('selectedStudent');
            return s ? (JSON.parse(s)?.clss || 'NURSERY') : 'NURSERY';
        } catch {
            return 'NURSERY';
        }
    };

    useEffect(() => {
        LiveClasses();
    }, []);

    const LiveClasses = async () => {
        setIsLoading(true);
        try {
            const response = await serviceApi.get(
                `${environment.liveClasses}&clss=${getEffectiveClass()}`
            );
            if (response.status === 'SUCCESS' && response.objectData?.knowledgeItems) {
                setLiveClasses(response.objectData.knowledgeItems);
            }
        } catch (error) {
            console.error("Error fetching live classes:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const openInNewTab = (url: string) => {
        window.open(url, '_blank');
    };

    // if (selectedUrl) {
    //     return (
    //         <div className='event-container'>
    //             <div className="col-12 no-padding">
    //                 <iframe
    //                     src={selectedUrl}
    //                     width="100%"
    //                     height="700"
    //                     frameBorder="0"
    //                     allow="camera; microphone; display-capture; autoplay"
    //                 ></iframe>
    //                 <div className="text-center pad10" style={{ textAlign: 'center', marginTop: '15px' }}>
    //                     <button className="go-button" onClick={() => openInNewTab(selectedUrl)}>
    //                         Open in New Tab
    //                     </button>
    //                     <button
    //                         className="go-button"
    //                         style={{ background: '#666', marginLeft: '10px' }}
    //                         onClick={() => setSelectedUrl(null)}
    //                     >
    //                         Close Class
    //                     </button>
    //                 </div>
    //             </div>
    //         </div>
    //     );
    // }

    return (
        <>
            <h2 className="title-text notification-heading">Live Classes</h2>
            <div className='event-container'>
                {isLoading && (
                    <div className="loading-overlay">
                        <div className="loading-overlay__content">
                            <div className="spinner spinner--lg"></div>
                            <span className="loading-text">Loading liveclasses...</span>
                        </div>
                    </div>
                )}
                <div className='live-classes-wrapper'>
                    {liveClasses.length > 0 ? (
                        liveClasses.map((item, idx) => (
                            <div key={idx} className='event-item' style={{ marginBottom: '20px', display: 'block' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <strong className="subtitle-text" style={{ color: 'var(--orange-color, #ff9800)', fontSize: '1rem' }}>
                                        {item.subject}
                                    </strong>
                                    <span className='event-date'>
                                        <i className='fa-regular fa-clock colorOrange'></i> {item.time} - {item.endTime}
                                    </span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginTop: '12px' }}>
                                    <div style={{ flex: 1 }}>
                                        <span className='event-description' style={{ fontWeight: '600', fontSize: '1.1rem', color: '#333', display: 'block' }}>
                                            {item.title}
                                        </span>
                                    </div>
                                    {item.isNow && (
                                        <button
                                            className='go-button'
                                            style={{ margin: 0, padding: '6px 25px', borderRadius: '4px' }}
                                            onClick={() => window.open(item.meetingUrl, '_blank')}
                                        >
                                            Start
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))
                    ) : (
                        !isLoading && <p className="event-description">No live classes scheduled for today.</p>
                    )}
                </div>
            </div>
        </>

    );
};

export default LiveClasses;